const globalStyles = {
 '.MuiPaper-root.MuiCard-root': {
  boxShadow: 'none',
  '.MuiCardContent-root': {
   //    padding: '12px',
  },
 },
 '.MuiButton-root': {
  whiteSpace: 'nowrap',
 },
 '.MuiButtonBase-root.MuiCheckbox-root': {
  //   padding: '0px',
 },
};
export default globalStyles;
